import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Globe, ArrowRight } from 'lucide-react';
import { countries } from '@/data/droneListings';
import { useNavigate } from 'react-router-dom';

export default function CountrySection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 sm:py-32 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-12">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
              <Globe className="w-8 h-8 text-primary" />
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
              Find UAVs & Drones For Sale By Country
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Explore drone listings from verified vendors in countries around the world
            </p>
          </div>

          {/* Country grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {countries.map((country, index) => (
              <Card
                key={country.slug}
                className={`group p-6 hover:shadow-lg hover:border-primary/50 cursor-pointer transition-all duration-300 animate-fade-in stagger-${(index % 6) + 1}`}
                onClick={() => navigate(`/country/${country.slug}`)}
              >
                <div className="text-center space-y-3">
                  <div className="text-4xl">{country.flag}</div>
                  <h3 className="font-semibold text-base group-hover:text-primary transition-colors">
                    {country.name}
                  </h3>
                  <div className="text-sm text-muted-foreground">
                    {country.count} UAVs
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="w-full group-hover:bg-primary/10 transition-colors"
                  >
                    Browse
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </div>
              </Card>
            ))}
          </div>

          {/* View more countries */}
          <div className="text-center mt-12">
            <Button size="lg" variant="outline" className="group">
              View All Countries
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}